var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
import { EventEmitter } from "@feng3d/event";
import { oav } from "@feng3d/objectview";
import { SerializeProperty, Serializable, getConstructor, getInstance } from "@feng3d/serialization";
function AddComponentMenu(component, path, componentOrder = 0) {
  return (_target) => {
    if (!menuConfig.component)
      menuConfig.component = [];
    menuConfig.component.push({ path, order: componentOrder, type: component });
    menuConfig.component.sort((a, b) => {
      if (a.path < b.path)
        return -1;
      return 1;
    });
    menuConfig.component.sort((a, b) => a.order - b.order);
  };
}
const menuConfig = {};
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
const __component__ = "__component__";
function RegisterComponent(component) {
  return (constructor) => {
    component = component || {};
    const info = component;
    info.name = info.name || component.name || constructor.name;
    info.type = constructor;
    info.dependencies = info.dependencies || [];
    constructor.prototype[__component__] = info;
    Serializable(info.name)(constructor);
    if (component.menu) {
      AddComponentMenu(component.name, component.menu, component.menuOrder)(constructor);
    }
  };
}
let Component = (_a = class {
  constructor(...args) {
    __publicField(this, "emitter", new EventEmitter(this));
    __publicField(this, "enabled", true);
    __publicField(this, "_entity");
    console.assert(args[0] === Component.constructorCode, `\u8BF7\u7EC4\u4EF6\u4F7F\u7528\u9ED8\u8BA4\u6784\u9020\u51FD\u6570\uFF0C\u5E76\u4F7F\u7528 Entity.addComponent \u8FDB\u884C\u65B0\u589E\u7EC4\u4EF6!`, this);
  }
  get entity() {
    return this._entity;
  }
  init() {
  }
  addComponent(type, params) {
    return this._entity.addComponent(type, params);
  }
  getComponent(component) {
    return this._entity.getComponent(component);
  }
  getComponents(type, results = []) {
    return this._entity.getComponents(type, results);
  }
  getShareTargets() {
    return [this._entity];
  }
  destroy() {
    this.enabled = false;
    this._entity = null;
  }
  setEntity(entity) {
    this._entity = entity;
  }
  static __create__() {
    return new this(Component.constructorCode);
  }
  static getDependencies(component) {
    var _a2;
    const Constructor2 = getConstructor(component);
    let dependencies = [];
    let prototype = Constructor2 == null ? void 0 : Constructor2.prototype;
    while (prototype) {
      dependencies = dependencies.concat(((_a2 = prototype[__component__]) == null ? void 0 : _a2.dependencies) || []);
      prototype = prototype.__proto__;
    }
    return dependencies;
  }
  static isSingleComponent(component) {
    var _a2;
    const Constructor2 = getConstructor(component);
    let prototype = Constructor2.prototype;
    let isSingle = false;
    while (prototype && !isSingle) {
      isSingle = !!((_a2 = prototype[__component__]) == null ? void 0 : _a2.single);
      prototype = prototype.__proto__;
    }
    return isSingle;
  }
}, __publicField(_a, "constructorCode", Math.random()), _a);
__decorateClass$1([
  oav(),
  SerializeProperty()
], Component.prototype, "enabled", 2);
Component = __decorateClass$1([
  RegisterComponent({ name: "Component" })
], Component);
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class Entity {
  constructor() {
    __publicField(this, "emitter", new EventEmitter(this));
    __publicField(this, "_components", []);
  }
  get components() {
    return this._components.concat();
  }
  set components(value) {
    if (!value)
      return;
    for (let i = 0, n = value.length; i < n; i++) {
      const component = value[i];
      if (!component)
        continue;
      const single = Component.isSingleComponent(component.constructor);
      if (single) {
        this.removeComponentsByType(component.constructor);
      }
      this.addComponentAt(value[i], this.numComponents);
    }
  }
  get numComponents() {
    return this._components.length;
  }
  addComponent(componentName, params) {
    let component = this.getComponent(componentName);
    if (component && Component.isSingleComponent(componentName)) {
      return component;
    }
    const dependencies = Component.getDependencies(componentName);
    dependencies.forEach((dependency) => {
      this.addComponent(dependency);
    });
    component = getInstance(componentName, params);
    this.addComponentAt(component, this._components.length);
    return component;
  }
  getComponent(componentName) {
    const Constructor2 = getConstructor(componentName);
    for (let i = 0; i < this._components.length; i++) {
      const compnent = this._components[i];
      if (compnent instanceof Constructor2) {
        return compnent;
      }
    }
    return null;
  }
  getComponents(component, results = []) {
    const Constructor2 = getConstructor(component);
    for (let i = 0; i < this._components.length; i++) {
      const component2 = this._components[i];
      if (component2 instanceof Constructor2) {
        results.push(component2);
      }
    }
    return results;
  }
  getComponentAt(index) {
    console.assert(index < this.numComponents, "\u7ED9\u51FA\u7D22\u5F15\u8D85\u51FA\u8303\u56F4");
    return this._components[index];
  }
  setComponentIndex(component, index) {
    console.assert(index >= 0 && index < this.numComponents, "\u7ED9\u51FA\u7D22\u5F15\u8D85\u51FA\u8303\u56F4");
    const oldIndex = this._components.indexOf(component);
    console.assert(oldIndex >= 0 && oldIndex < this.numComponents, "\u5B50\u7EC4\u4EF6\u4E0D\u5728\u5BB9\u5668\u5185");
    this._components.splice(oldIndex, 1);
    this._components.splice(index, 0, component);
  }
  setComponentAt(component, index) {
    if (this._components[index]) {
      this.removeComponentAt(index);
    }
    this.addComponentAt(component, index);
  }
  removeComponent(component) {
    console.assert(component.entity === this, "\u53EA\u80FD\u79FB\u9664\u5728\u5BB9\u5668\u4E2D\u7684\u7EC4\u4EF6");
    const index = this.getComponentIndex(component);
    this.removeComponentAt(index);
  }
  getComponentIndex(component) {
    console.assert(this._components.indexOf(component) !== -1, "\u7EC4\u4EF6\u4E0D\u5728\u5BB9\u5668\u4E2D");
    const index = this._components.indexOf(component);
    return index;
  }
  removeComponentAt(index) {
    console.assert(index >= 0 && index < this.numComponents, "\u7ED9\u51FA\u7D22\u5F15\u8D85\u51FA\u8303\u56F4");
    const component = this._components.splice(index, 1)[0];
    this.emitter.emit("removeComponent", { component, entity: this }, true);
    component.destroy();
    return component;
  }
  swapComponentsAt(index1, index2) {
    console.assert(index1 >= 0 && index1 < this.numComponents, "\u7B2C\u4E00\u4E2A\u5B50\u7EC4\u4EF6\u7684\u7D22\u5F15\u4F4D\u7F6E\u8D85\u51FA\u8303\u56F4");
    console.assert(index2 >= 0 && index2 < this.numComponents, "\u7B2C\u4E8C\u4E2A\u5B50\u7EC4\u4EF6\u7684\u7D22\u5F15\u4F4D\u7F6E\u8D85\u51FA\u8303\u56F4");
    const temp = this._components[index1];
    this._components[index1] = this._components[index2];
    this._components[index2] = temp;
  }
  swapComponents(a, b) {
    console.assert(a.entity === this, "\u7B2C\u4E00\u4E2A\u5B50\u7EC4\u4EF6\u4E0D\u5728\u5BB9\u5668\u4E2D");
    console.assert(b.entity === this, "\u7B2C\u4E8C\u4E2A\u5B50\u7EC4\u4EF6\u4E0D\u5728\u5BB9\u5668\u4E2D");
    this.swapComponentsAt(this.getComponentIndex(a), this.getComponentIndex(b));
  }
  removeComponentsByType(component) {
    const Constructor2 = getConstructor(component);
    const removeComponents = [];
    for (let i = this._components.length - 1; i >= 0; i--) {
      if (this._components[i].constructor === Constructor2) {
        removeComponents.push(this.removeComponentAt(i));
      }
    }
    return removeComponents;
  }
  addComponentAt(component, index) {
    if (!component) {
      return;
    }
    console.assert(index >= 0 && index <= this.numComponents, "\u7ED9\u51FA\u7D22\u5F15\u8D85\u51FA\u8303\u56F4");
    if (component.entity === this) {
      index = Math.min(index, this._components.length - 1);
      this.setComponentIndex(component, index);
      return;
    }
    const single = Component.isSingleComponent(component);
    if (single) {
      this.removeComponentsByType(component.constructor);
    }
    this._components.splice(index, 0, component);
    component.setEntity(this);
    component.init();
    this.emitter.emit("addComponent", { component, entity: this }, true);
  }
  getShareTargets() {
    return this.components;
  }
  destroy() {
    for (let i = this._components.length - 1; i >= 0; i--) {
      const compnent = this.removeComponentAt(i);
      compnent.destroy();
    }
    this._components = null;
  }
}
__decorateClass([
  SerializeProperty(),
  oav({ priority: -2, component: "OAVEntityName" })
], Entity.prototype, "name", 2);
__decorateClass([
  SerializeProperty(),
  oav({ component: "OAVComponentList" })
], Entity.prototype, "components", 1);
export {
  AddComponentMenu,
  Component,
  Entity,
  RegisterComponent,
  menuConfig
};
//# sourceMappingURL=index.js.map
